import { render } from "./FormImage.vue?vue&type=template&id=0742dacb"
import script from "./FormImage.vue?vue&type=script&lang=js"
export * from "./FormImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__